<div class="flex flex-col gap-2">
    <!-- Value display -->
    @if (showValue) {
        <div class="text-center">
            <span
                class="inline-flex min-w-[3rem] items-center justify-center rounded-lg bg-primary-50 px-3 py-1 text-lg font-bold text-primary-700"
            >
                {{ value }}
            </span>
        </div>
    }

    <!-- Slider track -->
    <div
        class="relative flex items-center"
        [class.opacity-50]="disabled"
        [class.cursor-not-allowed]="disabled"
    >
        <!-- Min label -->
        @if (showMinMax) {
            <span class="me-3 text-xs text-slate-500">
                {{ min }}
            </span>
        }

        <!-- Track container -->
        <div
            #track
            class="relative h-2 flex-1 cursor-pointer rounded-full bg-slate-200 transition-colors"
            [class.cursor-not-allowed]="disabled"
            (click)="onTrackClick($event)"
        >
            <!-- Filled track -->
            <div
                class="absolute inset-y-0 start-0 rounded-full bg-primary-500 transition-all"
                [class.bg-slate-400]="disabled"
                [style.width.%]="percentage"
            ></div>

            <!-- Thumb -->
            <div
                class="absolute top-1/2 h-5 w-5 -translate-y-1/2 cursor-grab rounded-full border-2 border-primary-500 bg-white shadow-md transition-all hover:scale-110 focus:outline-none focus:ring-4 focus:ring-primary-100 active:scale-105 active:cursor-grabbing"
                [class.border-slate-400]="disabled"
                [class.cursor-not-allowed]="disabled"
                [class.hover:scale-100]="disabled"
                [class.active:scale-100]="disabled"
                [class.shadow-lg]="isDragging"
                [class.scale-110]="isDragging"
                [style.inset-inline-start]="'calc(' + percentage + '% - 10px)'"
                tabindex="0"
                role="slider"
                [attr.aria-valuenow]="value"
                [attr.aria-valuemin]="min"
                [attr.aria-valuemax]="max"
                [attr.aria-disabled]="disabled"
                (mousedown)="onThumbMouseDown($event)"
                (touchstart)="onThumbTouchStart($event)"
                (keydown)="onKeyDown($event)"
            >
                <!-- Tooltip on drag -->
                @if (isDragging && !showValue) {
                    <div
                        class="absolute -top-8 left-1/2 -translate-x-1/2 rounded bg-slate-800 px-2 py-1 text-xs font-medium text-white shadow-lg"
                    >
                        {{ value }}
                        <div
                            class="absolute -bottom-1 left-1/2 h-2 w-2 -translate-x-1/2 rotate-45 bg-slate-800"
                        ></div>
                    </div>
                }
            </div>
        </div>

        <!-- Max label -->
        @if (showMinMax) {
            <span class="ms-3 text-xs text-slate-500">
                {{ max }}
            </span>
        }
    </div>
</div>
